import React, { useState } from 'react';
import { connect } from 'react-redux';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import contentResolver from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { ResultatValg } from '../Store/Resultat/Types';
import { VeilederSlettingAvRenterAppState } from '../Store/index';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import VeilederSlettingAvRenterDto from '../Models/VeilederSlettingAvRenterDto';

interface InfoboksOwnProps {
    onChangeHandler: any;
    eventId: string | null;
}

type InfoboksDisplayProps = InfoboksOwnProps & MapStateToProps;

function Infoboks(props: InfoboksDisplayProps): JSX.Element {
    const { epiContext, eventId } = props;

    const [visVilkarAModal, setVisVilkarAModal] = useState(false);

    function onVilkarAClick(): void {
        setVisVilkarAModal(true);
    }

    function onRequestLukkVilkarA(): void {
        setVisVilkarAModal(false);
    }

    function nesteStegHandler(e: React.SyntheticEvent<HTMLButtonElement>): void {
        e.preventDefault();
        props.onChangeHandler(true);
    }

    function hentListe(): JSX.Element[] | null {
        if (epiContext.epiModel?.punktlisteA === undefined) return null;

        let liste: JSX.Element[] = [];

        for (let i = 0; i < epiContext.epiModel?.punktlisteA.value.length; i++) {
            liste.push(
                <li className="aubergine-dots" key={i}>
                    {epiContext.epiModel?.punktlisteA.value[i]}
                </li>,
            );
        }
        return liste;
    }

    return (
        <div className="c-veileder__panel   c-veileder__panel--input-white" id="boks-a">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <h3 className="c-veileder--overskrift c-veileder--overskrift-stor">
                        {contentResolver(epiContext, 'tittelA')}
                    </h3>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <div className="c-veileder--tekstomraade">{contentResolver(epiContext, 'infotekstA')}</div>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <h4 className="c-veileder__undersporsmal">{contentResolver(epiContext, 'ledetekstA')}</h4>
                    <ul className="c-veileder--standard-liste">{hentListe()}</ul>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <div className="c-veileder--kontainer--for-mobil">
                        <button
                            type="button"
                            className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine"
                            onClick={onVilkarAClick}
                        >
                            {contentResolver(epiContext, 'modalLenketekst')}
                        </button>
                        <ModalCompontent
                            isOpen={visVilkarAModal}
                            onRequestClose={onRequestLukkVilkarA}
                            ariaCloseText={resolveRawText(epiContext, 'modalVilkarAriaLabel')}
                            eventId={eventId}
                        >
                            <ArticleContentComponent
                                headerinnhold={contentResolver(epiContext, 'modalVilkarTittel')}
                                contentinnhold={contentResolver(epiContext, 'modalVilkarContent')}
                            />
                        </ModalCompontent>
                    </div>
                </div>
                <div className="c-veileder__content c-veileder__content--indented">
                    <button onClick={nesteStegHandler} className="c-knapp c-knapp--cta c-knapp--primary">
                        {contentResolver(epiContext, 'knappetekstA')}
                    </button>
                </div>
            </div>
        </div>
    );
}

interface MapStateToProps {
    epiContext: EpiContext<VeilederSlettingAvRenterDto>;
    resultat: ResultatValg;
}

export default connect((state: VeilederSlettingAvRenterAppState, ownProps: InfoboksOwnProps): MapStateToProps => {
    return {
        epiContext: state.epiContext,
        resultat: state.resultat,
    };
})(Infoboks);
